<template>
    <li :class="updateBorderClass">
        <router-link
            v-if="!menuItem.isExternal"
            :to="getTarget"
            :class="anchorClassObj"
            class="block text-white px-4 py-3"
            @click.native="handleClicked()"
        >
            <p class="inline">{{ menuItem.name }}</p>
            <i v-if="menuItem.isParent" class="fas fa-chevron-right float-right mt-1"></i>
            <i v-if="menuItem.isExternal" class="far fa-external-link float-right mt-1"></i>
        </router-link>

        <a 
            v-if="menuItem.isExternal"
            :target="getTarget" 
            @click="handleClicked()" 
            :class="anchorClassObj"
            class="block text-white px-4 py-3"
        >
            <p class="inline">{{ menuItem.name }}</p>
            <i v-if="menuItem.isParent" class="fas fa-chevron-right float-right mt-1"></i>
            <i v-if="menuItem.isExternal" class="far fa-external-link float-right mt-1"></i>
        </a>

        <ul v-if="menuItem.isParent">
            <MenuItem
                v-for="(subMenu, idx) in getChildren"
                :key="menuItem.name + idx"
                :menuItem="subMenu"
                :menuArr="menuArr"
                v-on:click-action="$emit('click-action')"
            />
        </ul>
    </li>
</template>

<style scoped>
li.parent {
    border-bottom: solid 1px rgb(255, 255, 255, 0.3);
}

li.child {
    border-bottom: solid 1px #d9efe6;
}

li.child:last-child {
    border: 0;
}
a:hover {
    background: rgba(0, 0, 0, 0.2);
    color: white;
}

@keyframes animateOpen {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(90deg);
    }
}

@keyframes animateClose {
    from {
        transform: rotate(90deg);
    }
    to {
        transform: rotate(0deg);
    }
}

a.expand svg {
    animation: animateOpen;
    animation-duration: 0.25s;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
}

a.contract svg {
    animation: animateClose;
    animation-duration: 0.25s;
    animation-timing-function: linear;
}
</style>
<script>
import { mapGetters } from "vuex"
import { Plugins } from "@capacitor/core";
const { Browser } = Plugins;

export default {
    name: "MenuItem",
    props: {
        menuItem: {
            required: true,
            type: Object,
        },
        menuArr: {
            required: true,
            type: Array,
        },
    },
    computed: {
        ...mapGetters("navigation", ["isExpanded"]),
        /**
         * update anchor tag based on a variety of parameter
         */
        anchorClassObj: function() {
            return {
                "bg-white": this.menuItem.isChild,
                "text-light-blue-400": this.menuItem.isChild,
                "pl-8": this.menuItem.isChild,
                expand: this.menuItem.isParent && this.isExpanded,
                contract: this.menuItem.isParent && !this.isExpanded,
            };
        },
        /**
         * update border color based on if menuItem is child
         */
        updateBorderClass() {
            if (this.menuItem.isChild) {
                return "child";
            } else {
                return "parent";
            }
        },
        /**
         * get children menu items that match the selected menuItem
         */
        getChildren() {
            return this.menuArr.filter((item) => item.parent === this.menuItem.name);
        },

        getTarget() {
            if (this.menuItem.isExternal) {
                return "_blank";
            } else if (this.menuItem.isParent) {
                return "";
            } else {
                return this.menuItem.url
            }
        }
    },
    methods: {
        /**
         * menu item clicked listener
         */
        handleClicked() {
            if (this.menuItem.isParent) {
                this.$store.commit("navigation/setIsExpanded", !this.isExpanded);
            } else {
                this.$emit("click-action");

                if (this.menuItem.isExternal) {
                    Browser.open({ url: this.menuItem.url });
                }
            }
        },
    }
};
</script>
